import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Line } from "@antv/g2plot";
import chartMixin from "../mixin/chartMixin";
export default {
  name: "CommunityActivity",
  mixins: [chartMixin],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getData: function getData() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var other, type, param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              other = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              type = _arguments.length > 1 ? _arguments[1] : undefined;
              param = {
                grain: _this.communityGrain,
                start: _this.dateTime[0],
                end: _this.dateTime[1],
                groupBy: ''
              };
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.$api.getPostChartData(_objectSpread(_objectSpread({}, param), other)).then(function (res) {
                  var data = res.data.map(function (i) {
                    return _objectSpread(_objectSpread({}, i), {}, {
                      category: type,
                      value: i.release_num || i.collect_num || i.comment_num || 0
                    });
                  });
                  resolve(data);
                }).catch(function (err) {
                  reject([]);
                });
              }));
          }
        }, _callee);
      }))();
    },
    getPostChartData: function getPostChartData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, Promise.all([_this2.getData({
                chartName: "ads_community_post_quota_release_chart",
                valueName: "release_num"
              }, "post"), _this2.getData({
                chartName: "ads_community_post_quota_comment_chart",
                valueName: "comment_num"
              }, "post_comment"), _this2.getData({
                chartName: "ads_community_post_quota_collect_chart",
                valueName: "collect_num"
              }, "post_like")]).then(function (res) {
                if (res.length) {
                  return res.flat(2);
                }
                return [];
              }));
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _this3.getPostChartData();
            case 1:
              data = _context3.v;
              _this3.loading = false;
              if (_this3.lineChart) {
                _this3.lineChart.changeData(data);
              } else {
                _this3.lineChart = new Line("community-activity", {
                  data: data,
                  xField: "time",
                  yField: "value",
                  seriesField: "category",
                  color: function color(_ref) {
                    var category = _ref.category;
                    console.log();
                    var obj = {
                      post: "#6E94F3",
                      post_comment: "#5AD8A6",
                      post_like: "#F6BD16"
                    };
                    return obj[category] || "#6E94F3";
                  },
                  legend: {
                    position: "top",
                    offsetY: 70
                  },
                  smooth: true,
                  appendPadding: [70, 0, 0, 0]
                });
                _this3.lineChart.render();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    command: function command(type) {
      this.communityGrain = type;
      this.init();
    }
  }
};